import { createContext } from 'preact';

export const PreviewContext = createContext(null);
